<template>
    <div class="contact-cta-btns-container" ref="container">
        <div class="title">{{ $t("home.leftCTATitle") || "&nbsp;" }}</div>

        <transition name="cta-anim">
            <CTAButton position="left" href="mailto:contact@ar-go.co" v-if="ready">
                <i class="icon-mail" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton position="left" href="tel:+33 1 84 60 09 60" v-if="ready">
                <i class="icon-phone-call" />
            </CTAButton>
        </transition>

        <transition name="cta-anim">
            <CTAButton position="left" href="https://ar-go.co/" v-if="ready">
                <i class="argo-logo_masked" />
            </CTAButton>
        </transition>
    </div>
</template>
<script lang="ts">
import CTAButton from "@/components/CTAButton.vue";

export default {
    name: "ContactCTAButtons",
    components: {
        CTAButton
    },
    data() {
        return {
            ready: false
        };
    },

    mounted() {
        setTimeout(() => {
            this.ready = true;
        }, 200);
    }
};
</script>
<style scoped>
.contact-cta-btns-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
    --animation-duration: 150;
}

.title {
    color: var(--screenTextColor);
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 5px;
    margin-right: 3px;
}

.cta-button:nth-of-type(2) {
    animation-delay: calc(var(--animation-duration) * 1ms);
    transition-delay: calc(var(--animation-duration) * 1ms);
}

.cta-button:nth-of-type(3) {
    animation-delay: calc(var(--animation-duration) * 2ms);
    transition-delay: calc(var(--animation-duration) * 2ms);
}

.argo-logo_masked {
    mask: url("../assets/argo-logo.png") center / contain;
    width: 100%;
    height: 100%;
    background-color: var(--buttonTextColor);
}

.cta-button > * {
    margin-left: 4px;
}

.cta-button > img {
    height: 100%;
}
</style>
